/**
 * Startup-validation coordination flag (leaf module — imports nothing).
 *
 * During the optimistic session restore, the shell renders immediately from the
 * decoded JWT and `/auth/me` validates in the background. In that window, the
 * landing page's data queries may also fire; if the session turned out to be
 * terminally dead, those queries 401 too. Without coordination, the GLOBAL
 * `handleSessionExpiry` (query-client) would then log the user out AND toast
 * "session expirée" on a plain cold reload — which is wrong (there was no live
 * session that "expired") and duplicates the restore hook's own handling.
 *
 * So while this flag is set, `handleSessionExpiry` DEFERS: `useSessionRestore`
 * is the single authority on the startup terminal-401 outcome, and it ends the
 * session silently (matching the pre-existing cold-start behavior). Once the
 * background validation resolves, normal mid-session 401 handling resumes.
 */

let validating = false;

export function beginSessionValidation(): void {
  validating = true;
}

export function endSessionValidation(): void {
  validating = false;
}

export function isSessionValidating(): boolean {
  return validating;
}
